/**
 * Auto-generated from dark-roast/api-envoy OpenAPI spec. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { z } from 'zod';
import { type TagEntity, tagSchema } from '@axiom/domain';

export const tagSearchResultDtoSchema = tagSchema.pick({ "id": true, "name": true }).extend({ "type": z.string().nullish() });
export type TagSearchResultDto = Pick<TagEntity, "id" | "name"> & z.infer<typeof tagSearchResultDtoSchema>;
